export class TimeoutError extends Error {
    constructor(msg: string) {
        super(msg);

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, TimeoutError.prototype);
    }
}
